import React from 'react';

function DownloadPapers() {
  const papers = [
    {
      title: "2024 Henry Park Primary School - P6 - SA2 (Prelim) - Paper 2",
      url: "https://chatbotmia.blob.core.windows.net/assets/henrypark_p6_sa2_2024_paper_2_with_cover.pdf",
    },
    {
      title: "2024 Taonan Primary School- P6 - SA2 (Prelim) - Paper 2",
      url: "https://chatbotmia.blob.core.windows.net/assets/P6_Science_2024_SA2_taonan_paper2_with_cover.pdf",
    },
    {
      title: "2024 Nanyang Primary School - P6 - SA2 (Prelim) - Paper 2",
      url: "https://chatbotmia.blob.core.windows.net/assets/Nanyang_P6_2024_Paper_2_with_cover.pdf",
    },
    {
      title: "2024 Raffles Girls Primary School - P6 - SA2 (Prelim) - Paper 2",
      url: "https://chatbotmia.blob.core.windows.net/assets/RGPS_P6_2024_Paper2_with_cover.pdf",
    },
  ];

  return (
    <div style={{ padding: '2rem' }}>
      <h1>Download Test Papers</h1>
      <p style={{ fontStyle: 'italic', color: '#555', marginBottom: '1rem' }}>
        Disclaimer: We do not own any of the soft copy/download links posted on this website. All credits and copyrights
        belong to the respective schools.
      </p>
      <p style={{ fontStyle: 'italic', color: '#555', marginBottom: '2rem' }}>
        Note: Answer keys are not included. You can use our app to grade and mark your completed answer scripts.
      </p>
      <ul>
        {papers.map((paper, index) => (
          <li key={index} style={{ marginBottom: '1rem' }}>
            <a href={paper.url} target="_blank" rel="noopener noreferrer">
              {paper.title}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default DownloadPapers;
